/**
 * Changes made:
 * - 2026-02-16: Created public hook to fetch the 7 most recent approved seller reviews
 */

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ApprovedReview {
  id: string;
  rating: number;
  review_text: string;
  seller_name: string;
  car_title: string;
  created_at: string;
}

export const useApprovedReviews = () => {
  return useQuery({
    queryKey: ['approved_reviews'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('seller_reviews')
        .select('id, rating, review_text, seller_name, car_title, created_at')
        .eq('status', 'approved')
        .order('created_at', { ascending: false })
        .limit(7);
      if (error) throw error;
      return data as ApprovedReview[];
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
};
